import GenerateDefinitions from './GenerateDefinitions';
import { translateSchema } from '../../../../i18n/translateHelper';

export default function GenerateSchemaForFlow (data) {
  const schema = {
    title: 'processDetail:customFlowTitle',
    type: 'object',
    properties: {
      steps: {
        title: 'processDetail:configureStep',
        type: 'array',
        items: {
          $ref: '#/definitions/signatures'
        },
        minItems: 1
      }
    },
    definitions: GenerateDefinitions(data)
  };
  const translatedSchema = translateSchema(schema);
  return translatedSchema;
}
